module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAbCAYAAAB836/YAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3UlEQVRIiaXTwQ6CMAyA4X8GvehFEyW+nI8ikRf26EEjHmCG1bWjswnJNuiXdhvheUGLoMyHafzOJTUqN74bMmhcc4NrAQYxf3nBjcCYgQF4eMHtDJH7CXD3grvZOLYr23aBe9IWycxd4CGTbFZXAk9KVdUtt6QHoh3OYvAsIIlXg67wVCjHbrBV1s27aIFHZd2ssnSx3bGqSSqBV8Y25FOKXE7XAP30we3P4jqgjy3308JfGKR7WIt+MQnWoAmWAz3oD6aBS9AsZoEWqmIlMIeaGNi/3hyN/6+JAXwAVj07lQGrrNEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/mobile/ic_arow.png
// module id = YMN5
// module chunks = 2